namespace SPA
{
	export namespace EXPOSE
	{
		export class New
			extends ui.tab.TabHTMLPresentation
		{

			private mForm: 											ui.Form.Form;
			private mObjectData: 								ui.Box.Box;
			private theObject:									any;
			private select:											any;

			public constructor( company: Wollmilch.CompanyObject, TheObject: Wollmilch.Realtor.Object|null = null)
			{
				super();

				this.Initialize( {} );

				this.mObjectData										= new ui.Box.Box();
				this.theObject 											= TheObject;

				this.mForm = new ui.Form.Form(
				{
					action: 'expose/new/' + encodeURIComponent( btoa( this.theObject.ObjectNumber ) ),
					classes: [ 'form-horizontal' ],
					invalid: ( inputs: Array<ui.Form.BasicInputField<HTMLElement>> ) =>
					{
						app.addNotify(
						{
							body: [ ui.text( app.getMessage( 'EXPOSE.GENERAL.errorbody' ) ) ],
							context: 'danger',
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: [ ui.h( 4, app.getMessage( 'EXPOSE.GENERAL.errortitle' ) ) ],
						});
					},
					method: 'POST',
					notSwitchable: true,
					submit: ( methode: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
					{
						new Wollmilch.AJAX(
							{
								method: methode,
								on:
								{
									success: ( text: string ): void =>
									{
										let obj = null;
										try
										{
											obj = Wollmilch.jsonize( text );
										}
										catch ( e )
										{
											app.addNotify(
											{
												body: [ ui.text( app.getMessage( 'EXPOSE.GENERAL.errorbody' ) ) ],
												context: 'danger',
												timeout: Number(app.getConfigValue("ToastTimeout")),
												title: [ ui.h( 4, app.getMessage( 'EXPOSE.GENERAL.errortitle' ) ) ],
											});
											return;
										}
										if ( obj )
										{
											if ( !obj.success && obj.error )
											{
												app.addNotify(
												{
													body: [
														ui.text(
															'SchnittstellenFehler' +
															( typeof obj.error === 'string' ? obj.error : obj.error.msg )
														)
													],
													context: 'danger',
													timeout: Number(app.getConfigValue("ToastTimeout")),
													title: [ ui.h( 4, app.getMessage( 'EXPOSE.GENERAL.errortitle' ) ) ],
												});
												return;
											}

											const srcStr = 'data:application/pdf;base64,';
											let modal: ui.dialog.Modal;

											let imgType: any;
											imgType = ui.$$.iframe();

											modal = new ui.dialog.Modal(
											{
												// @ts-ignore
												body: [ imgType.attr('src', srcStr + obj.artifactData ).attr( 'width', '100%' ).attr( 'height', '700px' ) ],
												css:
												{
													cursor: 'zoom-out',
												},
												noCloseBtn: true,
												size: 'lg',
											} );
											modal.on( 'click', () => modal.Hide() );
										}
									},
								},
								url: action,
							},
							Wollmilch.AJAXCallbase_e.EXPOSE,
							).send();
					},
				},
				)
				.append(
					ui.$$.div().addClass( 'row' )
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
						.append( this.mObjectData.Root()),
					),
				) as ui.Form.Form;

				this.mObjectData.addTitle( app.getMessage( 'EXPOSE.GENERAL.boxtitle' ) );

				this.buildFields();

				this.append( this.mForm );

				this.mForm.Initialize();

				const btnSubmit = $( this.mForm.Buttons.submit.getElement() ).text( app.getMessage( 'EXPOSE.GENERAL.submit' ) );
				const btnCancel = $( this.mForm.Buttons.cancel.getElement() ).text( app.getMessage( 'EXPOSE.GENERAL.cancel' ) );

				new ui.Box.Box().append(
					ui.$$.div().append(
						ui.$$.div().append(
							ui.$$.div()
								.append( btnSubmit.attr( 'style', 'display: inline' ) )
								.append( btnCancel.attr( 'style', 'display: inline' ) )
									.on( 'click', () => app.getGlobalTabControl().removeTab( this.m_Entry ) )
							.addClass( 'col-xs-12' ),
						).addClass( 'row' ),
					).addClass( 'container-fluid' ),
				).attr('style', 'display: block' ).appendTo( ui.$$.div().addClass( 'row' )
					.appendTo( this.mForm.Root() ),
				);

				this.rebuild(this.Root());

				this.mForm.append(ui.$$.text('TODO:'))
					.append(ui.$$.br()).append(ui.$$.text('Auswahl von Template, per SelectBox'))
					.append(ui.$$.br()).append(ui.$$.text('Auswahl von Objektdaten, per click'))
					.append(ui.$$.br()).append(ui.$$.text('save PDF als Attachment in DB'));
			}

			public buildFields()
			{
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.mForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				};

				const fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.LABEL.MP01.enum') + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mObjectData.Root() );

				const inputArea = new ui.Form.Select(
				{
					name: 'area.selected',
					option:
					{
						bruttoarea: app.getMessage( 'BRW.INFO.bruttoarea' ),
						livingarea: app.getMessage( 'BRW.INFO.livingarea' ),
					},
				},
				);

				this.mObjectData.append( ui.$$.text('Area' ) );
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): New
			{
				super.rebuild( root );

				this.build();

				return this;
			}

			private build(): void
			{
				this.mObjectData.empty();
				this.mObjectData.rebuild().append( ui.$$.br() );

				this.mForm.clear();
			}

		}

	}

}
